<div class="home">
  <h1 class="mb-20">Přehled</h1>
  <mpv-statistics></mpv-statistics>
  <div class="mt-80">
    <h2>Upozornění</h2>
    <gmt-notifications></gmt-notifications>
  </div>
</div>
<help [helpId]="helpIds.PANEL_HOME" class="cm-help-page"></help>
